import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import { motion } from "framer-motion";
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router";
import { AppContext } from "../AppProvider";
import Time from "../Components/Timeline/Time";
import { ImagesSlider } from "../Components/ui/images-slider";
import CBSGCharLoader from "./CBSGCharLoader";

const About = () => {
  const { uri, images, About, loading } = useContext(AppContext);
  const aboutfilteredImages = images.filter(
    (image) => image.caption && image.caption.toLowerCase().includes("about")
  );
  const [loading1, setLoading1] = useState(true);
  const [error, setError] = useState(null);
  const [core, Setcore] = useState([]);

  useEffect(() => {
    setLoading1(true);
    axios
      .get(`${uri}core-competencies/`)
      .then((response) => {
        Setcore(response.data);
      })
      .catch((error) => {
        setError("Error fetching core competencies");
        setLoading1(false);
      });

    AOS.init({
      duration: 2000,
      offset: 10,
    });
  }, []);
  // console.log(core)
  if (loading1 && loading) {
    return (
      <div className="flex justify-center items-center h-[40rem]">
        <CBSGCharLoader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-[40rem]">
        <p className="text-red-500">Error: {error}</p>
      </div>
    );
  }

  return (
    <div className="text-base_900 mt-5 mb-10">
      <Helmet>
        <title>About Us - CBSG</title>
        <meta
          name="description"
          content="Learn more about CBSG, our mission, vision, and core values."
        />
        <meta
          name="keywords"
          content="CBSG, About, Mission, Vision, Core Values, Capacity Building, Service Group"
        />
        <meta name="author" content="CBSG Team" />
      </Helmet>
      <ImagesSlider
        className="h-[30rem] rounded-t border-t border-l border-r border-gray-300"
        images={aboutfilteredImages.map((item) => item.image)}
        overlay={true}
        data-aos="fade-up"
      >
        <motion.div
          initial={{ opacity: 0, y: -80 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9 }}
          className="z-50 flex flex-col justify-center items-center"
        >
          <motion.h1 className="font-extrabold text-xl md:text-6xl text-center py-4 p-6 rounded-lg text-white text-opacity-30 bg-clip-text bg-center hover:backdrop-blur-md backdrop-filter hover:text-opacity-60">
            About CBSG - Capacity Building Service Group
          </motion.h1>
        </motion.div>
      </ImagesSlider>

      <div
        className="w-full h-3 grid grid-cols-3 bg-black"
        data-aos="fade-right"
      >
        <div className="bg-base_500"></div>
        <div className="bg-yellow-500"></div>
        <div className="bg-violet-950"></div>
      </div>

      <div className="xl:px-72 mt-10 p-10" data-aos="fade-left">
        <h2 className="text-base md:text-2xl font-sans font-bold text-base_600 underline underline-offset-8">
          About CBSG
        </h2>
        <div
          className="text-justify font-normal mt-2"
          dangerouslySetInnerHTML={{ __html: About?.about_text }}
        />
      </div>

      <div
        className="w-full grid grid-cols-2 md:grid-cols-3 gap-5 xl:px-72 mt-10 justify-items-center p-10"
        data-aos="fade-up"
      >
        <div data-aos="fade-up" className="col-span-2 md:col-span-1">
          <div className="card ">
            <div className="card-body pt-0 pl-0">
              <h2 className="card-title font-sans font-bold text-base_600 underline underline-offset-8">
                <div className="flex items-center justify-center text-base md:text-2xl">
                  <p>Our Vision</p>
                </div>
              </h2>
              <div
                className="font-normal text-justify leading-relaxed tracking-wide hyphens-auto"
                dangerouslySetInnerHTML={{ __html: About?.vision_text }}
              />
            </div>
          </div>
        </div>
        <div data-aos="fade-right" className=" col-span-2">
          <div className="card">
            <div className="card-body pl-0 pt-0">
              <h2 className="card-title font-sans font-bold text-base_600 underline underline-offset-8">
                <div className="flex items-center justify-center text-base_600 text-2xl">
                  <p>Our Mission</p>
                </div>
              </h2>
              <div
                className="font-normal text-justify leading-relaxed tracking-wide hyphens-auto"
                dangerouslySetInnerHTML={{ __html: About?.our_mission }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="w-full grid grid-cols-2 md:grid-cols-3 gap-5 xl:px-72 justify-items-center p-10">
        <div className="card col-span-2 w-full" data-aos="fade-left">
          <div className="card-body pl-0">
            <h2 className="card-title font-sans font-bold text-base_600 underline underline-offset-8">
              <div className="flex items-center text-base md:text-2xl justify-center ">
                <p>Our Core Values</p>
              </div>
            </h2>
            <div
              className="font-normal text-justify"
              dangerouslySetInnerHTML={{ __html: About?.core_value_text }}
            />
          </div>
        </div>

        <div
          data-aos="flip-right"
          className="card shadow-md shadow-Coral_800 bg-gradient-to-r col-span-2 md:col-span-1 from-Coral_800 to-Coral_900 rounded-none transition ease-in-out delay-150 hover:translate-y-1 hover:scale-90 duration-400"
        >
          <div className="card-body text-white">
            <h2 className="card-title font-sans font-bold ">
              <div className="flex text-base md:text-2xl items-center justify-center ">
                <p>Integrity</p>
              </div>
            </h2>
            <div
              className="font-normal "
              dangerouslySetInnerHTML={{ __html: About?.integrity_text }}
            />
          </div>
        </div>
        <div
          data-aos="flip-right"
          className="card shadow-md shadow-Teal_700 bg-gradient-to-r from-Teal_800 to-Teal_800 rounded-none transition ease-in-out delay-150 hover:translate-y-1 hover:scale-210 duration-400 col-span-2 md:col-span-1"
        >
          <div className="card-body ">
            <h2 className="card-title font-sans font-bold text-white">
              <div className="flex items-center justify-center text-base md:text-2xl">
                <p>Commitment to Meaningful Change</p>
              </div>
            </h2>
            <div
              className="font-normal text-white"
              dangerouslySetInnerHTML={{ __html: About?.commitment_text }}
            />
          </div>
        </div>
        <div
          data-aos="flip-right"
          className="card shadow-md shadow-Golden_800 bg-gradient-to-r from-Golden_800 to-Golden_900 text-white rounded-none transition ease-in-out delay-150 hover:translate-y-1 hover:scale-210 duration-400 col-span-2 md:col-span-1"
        >
          <div className="card-body ">
            <h2 className="card-title font-sans font-bold ">
              <div className="flex items-center justify-center text-base md:text-2xl">
                <p>Ethical Practice</p>
              </div>
            </h2>
            <div
              className="font-normal "
              dangerouslySetInnerHTML={{ __html: About?.ethical_text }}
            />
          </div>
        </div>
        <div
          data-aos="flip-right"
          className="card col-span-2 md:col-span-1 shadow-md shadow-Corcol_Gray_800 bg-gradient-to-r from-Corcol_Gray_800 to-Corcol_Gray_900 text-white rounded-none transition ease-in-out delay-150 hover:translate-y-1 hover:scale-210 duration-400"
        >
          <div className="card-body ">
            <h2 className="card-title font-sans font-bold ">
              <div className="flex items-center text-base md:text-2xl justify-center">
                <p>Inclusivity and Adaptability</p>
              </div>
            </h2>
            <div
              className="font-normal "
              dangerouslySetInnerHTML={{ __html: About?.inclusivity_text }}
            />
          </div>
        </div>
      </div>

      <div className="xl:px-72 p-10" data-aos="fade-right">
        <h2 className="card-title text-base md:text-2xl text-base_600 pb-5 w-full underline underline-offset-8">
          Our Core Competencies
        </h2>

        <Core categories={core} />
      </div>
      <h2 className="text-xl md:text-3xl font-extrabold text-white lg:mx-72 bg-base_600 px-2 md:px-8 py-1 shadow-md shadow-base_300">
        History & Timeline
      </h2>
      <Time data-aos="flip-up" />
    </div>
  );
};

export const Core = ({ categories }) => {
  const bgColors = [
    "bg-gradient-to-r from-Teal_800 to-Teal_800 opacity-50",
    "bg-gradient-to-r from-Corcol_Gray_800 to-Corcol_Gray_900 opacity-50",
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {categories.map((category, index) => (
        <Link
          key={index}
          to={category?.link}
          className={`
            p-5 shadow-md  text-white
            ${bgColors[index % bgColors.length]}
          `}
          data-aos="fade-up"
        >
          <h3
            className="text-xl font-semibold transition-transform duration-300 
            hover:translate-y-[-1px] hover:scale-95 "
          >
            {category?.title}
          </h3>
        </Link>
      ))}
    </div>
  );
};

export default About;

Core.propTypes = {
  categories: PropTypes.array.isRequired,
};
